import { INIT, SUCCESS, ERROR, LOADING } from 'utils/asyncStatusHelper';
import get from 'lodash/get';
import {
	GET_RETURN_ADDRESSLIST_REQUEST,
	GET_RETURN_ADDRESSLIST_SUCCESS,
	GET_RETURN_ADDRESSLIST_ERROR
} from 'actions/SelfServeActions/returnAddressActions';
import { PINCODE_DETAIL } from 'actions/pincodeActions';

export default (state = { asyncStatus: INIT }, action = {}) => {
	switch (action.type) {
		case GET_RETURN_ADDRESSLIST_REQUEST:
			return Object.assign({}, state, { asyncStatus: LOADING });
		case GET_RETURN_ADDRESSLIST_SUCCESS:
			return Object.assign({}, state, { asyncStatus: SUCCESS, addressList: process(state, action) });
		case PINCODE_DETAIL.SUCCESS:
			return Object.assign({}, state, { asyncStatus: SUCCESS, city: action.city, state: action.state });
		case GET_RETURN_ADDRESSLIST_ERROR:
			return Object.assign({}, state, { asyncStatus: ERROR, error: action.error });
		default:
			return state;
	}
};

const process = (state, action) => {
	const addresses = get(action, ['data', 'customerAddress']);
	return addresses.map(address => {
		address.id = address.addressId;
		address.pincode = address.pinCode;
		address.phone = address.phoneNumber;
		delete address.pinCode;
		return address;
	});
};
